import React from "react";
import { Box, CircularProgress } from '@mui/material';
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";


const MonthlyAvgPriceGraph = ({ data, loading }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!data) return null;

  // Convert the data to Highcharts-compatible format
  const prices = data.map(item => [item.date, item.price]);
  const arrivals = data.map(item => [item.date, item.arrival]);

  // Check if there is any arrivals data (not null/undefined/empty/zero)
  const hasArrivalsData = arrivals.some(([_, value]) => value !== null && value !== undefined && value !== '' && value !== 0);

  const series = [
    {
      name: "Prices (INR Quintals)",
      type: "line",
      data: prices,
      color: "#F39C12",
      yAxis: 0,
    },
  ];
  if (hasArrivalsData) {
    series.push({
      name: "Arrivals (Tons)",
      type: "column",
      data: arrivals,
      color: "#2980B9",
      yAxis: 1,
    });
  }

  const yAxis = [
    {
      title: {
        text: "Prices (INR Quintals)",
        style: {
          color: "#0880EA",
        },
      },
      labels: {
        format: "{value}",
        style: {
          color: "#0880EA",
        },
      },
    },
  ];
  if (hasArrivalsData) {
    yAxis.push({
      title: {
        text: "Arrivals (Tons)",
        style: {
          color: "#2980B9",
        },
      },
      labels: {
        format: "{value}",
        style: {
          color: "#2980B9",
        },
      },
      opposite: true,
    });
  }

  const options = {
    series,
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      formatter: function () {
        return (
          "Average of <b>" +
          moment(this.x).format("MMM YYYY") +
          "</b>: <b>" +
          this.y +
          "</b>"
        );
      },
    },
    yAxis,
    xAxis: {
      type: "datetime",
      lineWidth: 1,
      lineColor: "#515151",
      tickColor: "#515151",
      tickInterval: 30 * 24 * 3600 * 1000,
      labels: {
        style: {
          fontSize: "10px",
          padding: "10px",
        },
        formatter: function () {
          return moment(this.value).format("MMM YYYY");
        },
      },
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default MonthlyAvgPriceGraph;
